const invertersData = [
  {
    id: "atp-3k-sp",
    name: "ATP 3.5 kW Hybrid – Single Phase",
    description:
      "High-efficiency hybrid solar inverter with advanced MPPT tracking and seamless integration for off-grid and on-grid applications.",
    image: "/assets/img/others/inverter-gallery-1.jpg",
    productOverview: {
      image: "/assets/img/product-3/inverter-3.5.webp",
      imageAlt: "Atom Power ATP 3.5kW hybrid single phase inverter",
      eyebrow: "Solar Inverter",
      title: "ATP 3.5 kW Hybrid – Single Phase",
      price: "Rs.148,000.00",
      compareAtPrice: "Rs.158,000.00",
      discountText: "Save 6%",
      note: "Tax included. Shipping calculated at checkout.",
      actions: [
        { label: "ADD TO CART", variant: "outline" },
        { label: "BUY IT NOW", to: "/contact", variant: "solid" },
      ],
      specs: [
        { label: "Max PV Capacity", value: "4 kW" },
        { label: "IP Rating", value: "IP 20" },
        { label: "Phase", value: "Single" },
        { label: "Warranty", value: "2 years" },
      ],
    },
    specifications: {
      "Off-Grid Output": {
        "Rated Output Power": "3,500 W",
        "Max Peak Power": "6,000VA",
        "Rated Output Voltage": "230Vac single phase",
        "Output Frequency Range": "50Hz ± 0.3Hz / 60Hz ± 0.3Hz",
      },
      "On-Grid Output": {
        "Rated Output Power": "3,500W",
        "Max Apparent Power": "6,000VA",
        "Rated Output Current": "15A",
        "Max Output Current": "17.2A",
        "Power Factor": "1",
        "Rated Voltage": "230Vac, single phase",
        Frequency: "50Hz/60Hz",
      },
      Battery: {
        "Battery Type": "Lead-acid / Li-ion / User Defined",
        "Rated Battery Voltage": "24V",
        "Battery Voltage Range": "20~33Vdc",
        "Max PV Charging Current": "80A",
        "Max Utility Charging Current": "80A",
        "Max Generator Charging Current": "80A",
      },
      "PV Input": {
        "Num of MPPT Trackers": "1",
        "Max PV Array Power": "4,000W",
        "Max Input Current": "13A",
        "Max Short-circuit Current": "17.2A",
        "Max Open-circuit Voltage": "500Vdc",
        "MPPT Operating": "120-450Vdc",
      },
      "Utility/Generator Input": {
        "Input Voltage Range": "90~280Vac",
        "Frequency Range": "50/60Hz",
        "Bypass Overload Current": "30A",
      },
      Efficiency: {
        "MPPT Tracking Efficiency": "99.90%",
        "Max Efficiency": "92%",
      },
      General: {
        Dimensions: "378×280×103mm",
        Weight: "7.4kg",
        "Protection Degree": "IP20",
        "Humidity Range": "0-100%",
        "Cooling Method": "Internal Fan",
      },
      Communication: {
        "Internal Interface": "RS485 / CAN / USB / Dry contact",
        "External Module (optional)": "Wi-Fi",
      },
      Certification: {
        "On-grid Certification": "",
        Safety: "CE(IEC 62109-1)/FCC/SAA",
        EMC: "EN61000, C2",
        RoHS: "Yes",
      },
    },

    features: [
      {
        title: "Efficiency",
        description:
          "Equipped with robust security features, this product meets multiple safety standards.",
        iconName: "FaCogs",
      },
      {
        title: "Safety",
        description:
          "Supports up to 80A charging current and seamless Li-ion battery BMS communication.",
        iconName: "FaShieldAlt",
      },
      {
        title: "All-in-One",
        description:
          "Features a modern industrial design, easy installation, and user-friendly operation.",
        iconName: "FaChargingStation",
      },
      {
        title: "Reliable",
        description:
          "Delivers high-quality pure sine wave AC power with IP20 protection.",
        iconName: "FaHandsHelping",
      },
      {
        title: "Intelligent",
        description:
          "Features advanced MPPT with up to 99.9% efficiency and dual PV input current of up to 13A each.",
        iconName: "FaLightbulb",
      },
    ],

    gallery: [
      "/assets/img/others/inverter-gallery-1.webp",
      "/assets/img/others/inverter-gallery-2.webp",
      "/assets/img/others/inverter-gallery-3.png",
    ],
  },
  {
    id: "atp-6k-sp",
    name: "ATP 6 kW Hybrid – Single Phase",
    description:
      "High-efficiency hybrid solar inverter with advanced MPPT tracking and seamless integration for off-grid and on-grid applications.",
    image: "/assets/img/others/inverter-gallery-1.jpg",
    productOverview: {
      image: "/assets/img/product-3/inverter-1.webp",
      imageAlt: "Atom Power ATP 6 kW hybrid single phase inverter",
      eyebrow: "Solar Inverter",
      title: "ATP 6 kW Hybrid - Single Phase",
      price: "Rs.148,000.00",
      compareAtPrice: "Rs.158,000.00",
      discountText: "Save 6%",
      note: "Tax included. Shipping calculated at checkout.",
      actions: [
        { label: "ADD TO CART", variant: "outline" },
        { label: "BUY IT NOW", to: "/contact", variant: "solid" },
      ],
      specs: [
        { label: "Max PV Capacity", value: "9 kWh" },
        { label: "IP Rating", value: "IP 65" },
        { label: "Phase", value: "Single" },
        { label: "Warranty", value: "5 years" },
      ],
    },
    specifications: {
      "Off-Grid Output": {
        "Rated Output Power": "6,000W",
        "Max Peak Power": "12,000VA",
        "Rated Output Voltage": "220/240V Single Phase",
        "Load Capacity of Motors": "4HP",
        "Output Frequency": "50Hz ± 0.3Hz / 60Hz ± 0.3Hz",
      },
      "On-Grid Output": {
        "Rated Output Power": "6,000W",
        "Max Apparent Power": "12,000VA",
        "Rated Output Current": "25A",
        "Max Output Current": "26A",
        "Power Factor": ">0.99",
      },
      Battery: {
        "Battery Type": "Lead-acid / Li-ion / User Defined",
        "Battery Voltage Range": "40~60Vdc",
        "Max PV Charging Current": "100A",
      },
      "PV Input": {
        "Max PV Input Power": "6,500W",
        "Num of MPPT Trackers": "2",
        "Max PV Input Current": "16A+16A",
        "MPPT Voltage Range": "120V - 500V",
        "Max Open Circuit Voltage": "500V",
      },
      "Utility/Generator Input": {
        "Voltage Range": "90-280Vac",
        "Frequency Range": "40Hz-65Hz",
        "Bypass Overload Current": "40A",
      },
      Efficiency: {
        Efficiency: "98%",
        "MPPT Tracking Efficiency": "99.9%",
      },

      Communication: {
        Communication: "Wi-Fi / GPRS",
      },
    },

    features: [
      {
        title: "Efficiency",
        description:
          "Equipped with robust security features, this product meets multiple safety standards.",
        iconName: "FaCogs",
      },
      {
        title: "Safety",
        description:
          "Supports up to 120A charging current and seamless Li-ion battery BMS communication.",
        iconName: "FaShieldAlt",
      },
      {
        title: "All-in-One",
        description:
          "Features a modern industrial design, easy installation, and user-friendly operation.",
        iconName: "FaChargingStation",
      },
      {
        title: "Reliable",
        description:
          "Delivers high-quality pure sine wave AC power with IP65 protection.",
        iconName: "FaHandsHelping",
      },
      {
        title: "User-Friendly",
        description:
          "Exclusive Li-ion battery BMS dual activation and a cost-saving time-slot function for efficiency.",
        iconName: "FaFan",
      },
      {
        title: "Intelligent",
        description:
          "Features advanced MPPT with up to 99.9% efficiency and dual PV input current of up to 22A each.",
        iconName: "FaLightbulb",
      },
    ],

    gallery: [
      "/assets/img/others/inverter-gallery-1.webp",
      "/assets/img/others/inverter-gallery-2.webp",
      "/assets/img/others/inverter-gallery-3.webp",
    ],
  },
  {
    id: "atp-10k-sp",
    name: "ATP 10 kW Hybrid – Single Phase",
    description:
      "A powerful hybrid inverter with 10,000W output, dual MPPT tracking, and seamless integration for off-grid and on-grid applications.",
    image: "/assets/img/others/inverter-gallery-2.jpg",
    productOverview: {
      image: "/assets/img/product-3/inverter-2.webp",
      imageAlt: "Atom Power ATP 10 kW hybrid single phase inverter",
      eyebrow: "Solar Inverter",
      title: "ATP 10 kW Hybrid - Single Phase",
      price: "Rs.148,000.00",
      compareAtPrice: "Rs.158,000.00",
      discountText: "Save 6%",
      note: "Tax included. Shipping calculated at checkout.",
      actions: [
        { label: "ADD TO CART", variant: "outline" },
        { label: "BUY IT NOW", to: "/contact", variant: "solid" },
      ],
      specs: [
        { label: "Max PV Capacity", value: "11 kWh" },
        { label: "IP Rating", value: "IP 65" },
        { label: "Phase", value: "Single" },
        { label: "Warranty", value: "5 years" },
      ],
    },
    specifications: {
      "Inverter Output": {
        "Rated Output Power": "10,000W",
        "Max Peak Power": "20,000VA",
        "Rated Output Voltage": "220/240V Single Phase",
        "Output Frequency": "50/60Hz",
      },
      Battery: {
        "Battery Type": "Lead-acid / Li-ion / User Defined",
        "Battery Voltage Range": "40~60Vdc",
        "Max PV Charging Current": "120A",
      },
      "PV Input": {
        "Max PV Input Power": "11,000W",
        "Num of MPPT Trackers": "2",
        "Max PV Input Current": "16A+16A",
        "MPPT Voltage Range": "120V - 500V",
      },
      Efficiency: {
        Efficiency: "97.5%",
        "MPPT Tracking Efficiency": "99.9%",
      },
      Communication: {
        Communication: "Wi-Fi / GPRS",
      },
    },

    features: [
      {
        title: "Efficiency",
        description:
          "Equipped with robust security features, this product meets multiple safety standards.",
        iconName: "FaCogs",
      },
      {
        title: "Safety",
        description:
          "Supports up to 200A charging current and seamless Li-ion battery BMS communication.",
        iconName: "FaShieldAlt",
      },
      {
        title: "All-in-One",
        description:
          "Features a modern industrial design, easy installation, and user-friendly operation.",
        iconName: "FaChargingStation",
      },
      {
        title: "Reliable",
        description:
          "Delivers high-quality pure sine wave AC power with IP65 protection.",
        iconName: "FaHandsHelping",
      },
      {
        title: "User-Friendly",
        description:
          "Exclusive Li-ion battery BMS dual activation and a cost-saving time-slot function for efficiency.",
        iconName: "FaFan",
      },
      {
        title: "Intelligent",
        description:
          "Features advanced MPPT with up to 99.9% efficiency and dual PV input current of up to 22A each.",
        iconName: "FaLightbulb",
      },
    ],
    gallery: [
      "/assets/img/others/inverter-gallery-1.webp",
      "/assets/img/others/inverter-gallery-2.webp",
      "/assets/img/others/inverter-gallery-3.webp",
    ],
  },
  {
    id: "atp-12k-h3p",
    name: "ATP 12 kW Hybrid – Three Phase",
    description:
      "High-performance 3-phase inverter with 12,000W output, up to 200A hybrid charging, and smart monitoring.",
    image: "/assets/img/others/inverter-gallery-3.jpg",
    productOverview: {
      image: "/assets/img/product-3/inverter-2.webp",
      imageAlt: "Atom Power ATP 12 kW hybrid three phase inverter",
      eyebrow: "Solar Inverter",
      title: "ATP 12 kW Hybrid - Three Phase",
      price: "Rs.148,000.00",
      compareAtPrice: "Rs.158,000.00",
      discountText: "Save 6%",
      note: "Tax included. Shipping calculated at checkout.",
      actions: [
        { label: "ADD TO CART", variant: "outline" },
        { label: "BUY IT NOW", to: "/contact", variant: "solid" },
      ],
      specs: [
        { label: "Max PV Capacity", value: "18 kWh" },
        { label: "IP Rating", value: "IP 65" },
        { label: "Phase", value: "three" },
        { label: "Warranty", value: "5 years" },
      ],
    },
    specifications: {
      "Inverter Output": {
        "Rated Output Power": "12,000W",
        "Max Peak Power": "24,000VA",
        "Rated Output Voltage": "Three-phase",
        "Output Frequency": "50/60Hz",
      },
      Battery: {
        "Battery Type": "Lead-acid / Li-ion / User Defined",
        "Battery Voltage Range": "40~60Vdc",
        "Max PV Charging Current": "120A",
      },
      "PV Input": {
        "Max PV Input Power": "18,000W",
        "Num of MPPT Trackers": "2",
        "Max PV Input Current": "37A+37A",
        "MPPT Voltage Range": "200V - 800V",
      },
      Efficiency: {
        Efficiency: "97.5%",
        "MPPT Tracking Efficiency": "99.9%",
      },
      Communication: {
        Communication: "Wi-Fi / GPRS",
      },
    },

    features: [
      {
        title: "Efficiency",
        description:
          "Equipped with robust security features, this product meets multiple safety standards.",
        iconName: "FaCogs",
      },
      {
        title: "Safety",
        description:
          "Supports up to 200A charging current and seamless Li-ion battery BMS communication.",
        iconName: "FaShieldAlt",
      },
      {
        title: "All-in-One",
        description:
          "Features a modern industrial design, easy installation, and user-friendly operation.",
        iconName: "FaChargingStation",
      },
      {
        title: "Reliable",
        description:
          "Delivers high-quality pure sine wave AC power with IP65 protection.",
        iconName: "FaHandsHelping",
      },
      {
        title: "User-Friendly",
        description:
          "Exclusive Li-ion battery BMS dual activation and a cost-saving time-slot function for efficiency.",
        iconName: "FaFan",
      },
      {
        title: "Intelligent",
        description:
          "Features advanced MPPT with up to 99.9% efficiency and dual PV input current of up to 22A each.",
        iconName: "FaLightbulb",
      },
    ],
    gallery: [
      "/assets/img/others/inverter-gallery-1.webp",
      "/assets/img/others/inverter-gallery-2.webp",
      "/assets/img/others/inverter-gallery-3.webp",
    ],
  },
  {
    id: "atp-20k-h3p",
    name: "ATP 20 kW Hybrid – Three Phase",
    description:
      "High-performance 3-phase inverter with 20,000W output, up to 200A hybrid charging, and smart monitoring.",
    image: "/assets/img/others/inverter-gallery-3.jpg",
    productOverview: {
      image: "/assets/img/product-3/inverter-20.png",
      imageAlt: "Atom Power ATP 20kW hybrid three phase inverter",
      eyebrow: "Solar Inverter",
      title: "ATP 20 kW Hybrid - Three Phase",
      price: "Rs.148,000.00",
      compareAtPrice: "Rs.158,000.00",
      discountText: "Save 6%",
      note: "Tax included. Shipping calculated at checkout.",
      actions: [
        { label: "ADD TO CART", variant: "outline" },
        { label: "BUY IT NOW", to: "/contact", variant: "solid" },
      ],
      specs: [
        { label: "Max PV Capacity", value: "30 kWh" },
        { label: "IP Rating", value: "IP 65" },
        { label: "Phase", value: "three" },
        { label: "Warranty", value: "5 years" },
      ],
    },
    specifications: {
      "Inverter Output": {
        "Rated Output Power": "20,000W",
        "Max Peak Power": "40000VA",
        "Rated Output Voltage": "Three-phase",
        "Output Frequency": "50/60Hz",
      },
      Battery: {
        "Battery Type": "Lead-acid / Li-ion / User Defined",
        "Battery Voltage Range": "40~60Vdc",
        "Max PV Charging Current": "120A",
      },
      "PV Input": {
        "Max PV Input Power": "18,000W",
        "Num of MPPT Trackers": "2",
        "Max PV Input Current": "37A+37A",
        "MPPT Voltage Range": "200V - 1000V",
      },
      Efficiency: {
        Efficiency: "97.5%",
        "MPPT Tracking Efficiency": "99.9%",
      },
      Communication: {
        Communication: "Wi-Fi / GPRS",
      },
    },

    features: [
      {
        title: "Efficiency",
        description:
          "Equipped with robust security features, this product meets multiple safety standards.",
        iconName: "FaCogs",
      },
      {
        title: "Safety",
        description:
          "Supports up to 200A charging current and seamless Li-ion battery BMS communication.",
        iconName: "FaShieldAlt",
      },
      {
        title: "All-in-One",
        description:
          "Features a modern industrial design, easy installation, and user-friendly operation.",
        iconName: "FaChargingStation",
      },
      {
        title: "Reliable",
        description:
          "Delivers high-quality pure sine wave AC power with IP65 protection.",
        iconName: "FaHandsHelping",
      },
      {
        title: "User-Friendly",
        description:
          "Exclusive Li-ion battery BMS dual activation and a cost-saving time-slot function for efficiency.",
        iconName: "FaFan",
      },
      {
        title: "Intelligent",
        description:
          "Features advanced MPPT with up to 99.9% efficiency and dual PV input current of up to 22A each.",
        iconName: "FaLightbulb",
      },
    ],
    gallery: [
      "/assets/img/others/inverter-gallery-1.webp",
      "/assets/img/others/inverter-gallery-2.webp",
      "/assets/img/others/inverter-gallery-3.webp",
    ],
  },
];

export default invertersData;
